import { UrlParamsSerializer } from '@immosky/shared';
import {
  CategoryFilterSerializer,
  ContractTypeFilterSerializer,
  LivingSpaceFilterSerializer,
  PriceFilterSerializer,
  PropertySpaceFilterSerializer,
  RadiusFilterSerializer,
  RegionFilterSerializer,
  RoomCountSerializer,
  SortFilterSerializer,
  SubcategoryFilterSerializer,
  UsageSpaceFilterSerializer,
} from '@immosky/object-search-filter';
import { AppState } from '@immosky/types';
import { PageIndexUrlSerializer } from '../state/results/search-results/page-index-url-serializer';
import { createUrlWithParams } from './url';

export class UrlParamsSynchronizer {
  static hasReadUrl = false;

  private static urlParamsSerializer = new UrlParamsSerializer([
    new CategoryFilterSerializer('category'),
    new SubcategoryFilterSerializer('subcategory'),
    new PriceFilterSerializer('price'),
    new RoomCountSerializer('room_count'),
    new LivingSpaceFilterSerializer('living_space'),
    new UsageSpaceFilterSerializer('usage_space'),
    new PropertySpaceFilterSerializer('property_space'),
    new RadiusFilterSerializer('radius'),
    new ContractTypeFilterSerializer('rent_or_buy'),
    new RegionFilterSerializer('region'),
    new SortFilterSerializer('sort'),
    new PageIndexUrlSerializer('page_index'),
  ]);

  static readUrlParams() {
    const searchParams = this.parseSearchParameters();
    this.hasReadUrl = true;
    return this.urlParamsSerializer.deserialize(searchParams);
  }

  static readInitialSearchTerm(): string {
    const searchParams = this.parseSearchParameters();
    return searchParams.get('search') || '';
  }

  private static parseSearchParameters(): URLSearchParams {
    return new URLSearchParams(window.location.search);
  }

  static onStateChange(state: AppState) {
    const newSearchParamsUrl = this.urlParamsSerializer.serialize(state);
    const newUrl = createUrlWithParams(newSearchParamsUrl);
    this.updateUrl(newUrl);
  }

  private static updateUrl(url: string) {
    window.history.replaceState(
      {
        path: url,
      },
      document.title,
      url
    );
  }
}
